"use client"
import type React from "react"

import { Button, Circle, Flex, Image, Text } from "@chakra-ui/react"

const bulletPoints: { text: string }[] = [
    {
        text: "We'll ask you for some information on this screen to set up your secure account"
    },
    { text: "You'll then be able to select the Platforms you want" },
    { text: "You'll be able to enter any promotional offer(s)" },
    { text: "We'll ask you for payment information" },
    { text: "You're good to go!" }
]

export const LogInImageBox: React.FC = () => (
    <Flex
        bgGradient='linear(to-br, green.400, blue.300)'
        borderRadius='xl'
        w={{ base: "full", xl: "60%" }}
        minH={{ base: "4vh", md: "50vh", xl: "calc(100vh - 4rem)" }}
        h='fit-content'
        color='white'
        p={{ base: 8, md: 10, xl: 12 }}
        flexDir='column'
        gap={4}
        position='relative'
        fontSize={{ base: "sm", lg: "md" }}
    >
        <Text
            fontSize={{ base: "2xl", md: "3xl", lg: "44px", "2xl": "50px" }}
            fontWeight='900'
            lineHeight='1.2'
            mb={{ lg: 2 }}
        >
            Welcome to the BrewLogix
            <sup className='text-[18px] lg:text-[24px]'>&reg;</sup> Platform Portal
        </Text>
        <Text>
            You can register for MarketMyBrewery<sup className='text-[8px]'>TM</sup>, BrewMenu
            <sup className='text-[8px]'>TM</sup>, and PerformancePlatform
            <sup className='text-[8px]'>TM</sup> all in one place. You&apos;re just a click away
            from increasing your on-premise draft program profitability.{" "}
        </Text>
        <Flex gap={3} flexDir='column' mb={2}>
            <Text fontSize={{ lg: "md", xl: "xl" }} fontWeight='bold'>
                What to expect:
            </Text>
            {bulletPoints.map(({ text }, index) => (
                <Flex key={text + index} gap={3} alignItems={{ base: "flex-start", sm: "center" }}>
                    <Circle size={7} color='white' fontWeight='bold' bg='rgba(255, 255, 255, .2)'>
                        {index + 1}
                    </Circle>
                    <Text mt={{ base: 1, sm: 0 }}>{text}</Text>
                </Flex>
            ))}
        </Flex>
        <Text w={{ md: "40%", xl: "50%" }}>
            If you&apos;d like to speak with us about setting up your account, you can{" "}
            <Button variant='link' color='green.300' fontSize={{ lg: "md" }}>
                <a target='_blank' rel='noreferrer' href='https://www.brewlogix.com/contact-sales/'>
                    reach us here
                </a>
            </Button>
            .
        </Text>
        <Text w={{ md: "40%", xl: "50%" }} fontWeight='bold'>
            Thanks for choosing BrewLogix. Let&apos;s create a Happy Hour Feeling together!
        </Text>

        <Image
            visibility={{ base: "hidden", md: "visible" }}
            position='absolute'
            bottom='0'
            right='0'
            src='/happy-hour-man.png'
            alt='Man with Happy Hour shirt'
            boxSize={{ base: "320px", lg: "400px", xl: "340px", "2xl": "450px" }}
            objectFit='contain'
        />
    </Flex>
)
